import { Injectable } from '@angular/core';
import { FspBuildingsGridDto } from './fsp-buildings-grid-data-model';
import { GridDataService } from '../../../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FspBuildingsGridDataService extends GridDataService<FspBuildingsGridDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
